import { useEffect, useState } from 'react'
import { CELULAR } from './styles'

/**
 * OP-3619 — a largura como estado, não como CSS.
 *
 * Serve ao que não dá para resolver com `display: none`: a barra de abas, que
 * no desktop não deve nem montar (a consulta dos contadores rodaria à toa), e
 * o recolhimento de linhas do "Hoje", que é decisão de celular — acima de
 * 767px a tela continua exatamente como era.
 */
export function useCelular(): boolean {
  const [celular, setCelular] = useState(
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(CELULAR).matches : false),
  )
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined
    const consulta = window.matchMedia(CELULAR)
    const ouvir = (e: MediaQueryListEvent) => setCelular(e.matches)
    setCelular(consulta.matches)
    consulta.addEventListener('change', ouvir)
    return () => consulta.removeEventListener('change', ouvir)
  }, [])
  return celular
}

export default useCelular
